"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFieldSchemaComponent = void 0;
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const fmko_ts_widgets_1 = require("fmko-ts-widgets");
const SchemaNavigationDefaultStrategy_1 = tslib_1.__importDefault(require("../../schema/SchemaNavigationDefaultStrategy"));
class TextFieldSchemaComponent extends fmko_ts_widgets_1.HasValueWidget {
    constructor(args) {
        super();
        this.element = document.createElement("div");
        this.element.classList.add("text-field-schema-component");
        this.textField = new fmko_ts_widgets_1.WCAGTextField(args);
        fmko_ts_common_1.DOM.setElementTabbable(this.textField.getFieldElement(), false);
        this.add(this.textField);
        const { renderingContext, hasUnitText = true, unitText, unitTextPlaceholder = "Enheder" } = args;
        if (hasUnitText) {
            this.unitTextPlaceholder = unitTextPlaceholder;
            this.unitText = document.createElement("span");
            this.unitText.id = fmko_ts_common_1.GlobalCounter.next();
            this.unitText.classList.add("unit-text");
            this.setUnitText(unitText);
            this.textField.getFieldElement().setAttribute(fmko_ts_common_1.ARIA.LABELLED_BY, this.unitText.id);
            this.add(this.unitText);
        }
        this.element.addEventListener("click", () => {
            this.textField.getFieldElement().focus();
        });
        this.textField.addValueChangeHandler(() => {
            fmko_ts_common_1.ValueChangeEvent.fire(this, this.getValue());
        });
        SchemaNavigationDefaultStrategy_1.default.addFieldElementListener({
            fieldElement: this.textField.getFieldElement(),
            renderingContext
        });
    }
    focus() {
        this.textField.focus();
    }
    getValue() {
        return {
            inputValue: this.textField.getValue(),
            unitValue: this.getUnitText()
        };
    }
    setValue(newValue, fireEvents = false) {
        const oldValue = this.getValue();
        const { inputValue, unitValue } = newValue || {};
        this.textField.setValue(inputValue);
        this.setUnitText(unitValue);
        if (fireEvents) {
            fmko_ts_common_1.ValueChangeEvent.fireIfNotEqual(this, oldValue, this.getValue());
        }
    }
    setEnabled(enabled) {
        this.textField.setEnabled(enabled);
    }
    getUnitText() {
        return this.unitText?.textContent;
    }
    setUnitText(unitText = this.unitTextPlaceholder) {
        if (!this.unitText) {
            return;
        }
        this.unitText.textContent = unitText;
    }
    clearValue(fireEvents) {
        const { unitValue } = this.getValue();
        this.setValue({ unitValue }, fireEvents);
    }
    click() {
        this.focus();
    }
    onCellFocusKeyDown(event) {
        if (!this.isEnabled()) {
            return;
        }
        if (!this.textField.isValidInputString(event.key)) {
            return;
        }
        this.clearValue();
        this.focus();
        this.textField.simulateCharacterPressed(event);
    }
    isEnabled() {
        return this.textField.isEnabled();
    }
}
exports.TextFieldSchemaComponent = TextFieldSchemaComponent;
//# sourceMappingURL=TextFieldSchemaComponent.js.map